/**
 * AboutのGoogleマップ
 */
import AnyStore from '../common/AnyStore';

export default class Gmap {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Gmap';

    // The location of office,
    this.office = {lat: 35.683693, lng: 139.698541};
    this.map = null;
    this.marker = null;
    this.size = {
      h: 86 * 0.75,
      w: 62 * 0.75
    };

    if (document.getElementById('map')) {
      this.init();
    }
  }

  /**
   * 初期化
   */
  init() {
    // googleマップのscriptタグ生成
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCo714aqYEuXBgBGJeMv5xWMWHU0u4H1ro&callback=initGmap';
    script.setAttribute('async', 'async');
    script.setAttribute('defer', 'defer');
    document.getElementsByTagName('head')[0].appendChild(script);

    // コールバック
    window.initGmap = this.initGmap.bind(this);
  }

  /**
   * Googleマップ設定（コールバック）
   */
  initGmap() {
    // The map, centered at office
    this.map = new google.maps.Map(
      document.getElementById('map'), {
        zoom: 18,
        center: this.office,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "hue": "#dd0d0d"
              }
            ]
          },
          {
            "elementType": "geometry.fill",
            "stylers": [
              {
                "hue": "#eb0281"
              },
              {
                "saturation": 100
              },
              {
                "lightness": 20
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }
        ]
      });

    this.setMarker(true);

    google.maps.event.addDomListener(window, "resize", this.resize.bind(this));
  }

  setMarker(isDrop) {
    let makerSize = {};

    if (AnyStore.setDevice() === 'sp') {
      makerSize.h = (this.size.h / 750) * AnyStore.getWindowWidth();
      makerSize.w = (this.size.w / 750) * AnyStore.getWindowWidth();
    } else {
      makerSize = this.size;
    }

    if (this.marker) this.marker.setMap(null);

    // The marker, positioned at office
    this.marker = new google.maps.Marker({
      position: this.office,
      map: this.map,
      icon: {
        url: '/manage/wp-content/themes/aas/assets/img/about/ico_map_marker.png',
        scaledSize: new google.maps.Size(makerSize.w, makerSize.h),
      },
      title: '株式会社アートアンドサイエンス',
      animation: isDrop ? google.maps.Animation.DROP : null,
    });
  }

  /**
   * リサイズ
   */
  resize() {
    this.setMarker(false);
  }
}
